import { Route } from '@angular/router';
import { AdminClientManagementComponent } from 'src/app/pages/admin/admin-client-management/admin-client-management.component';
import { AdminHomeComponent } from 'src/app/pages/admin/admin-home/admin-home.component';
import { AdminOverviewComponent } from 'src/app/pages/admin/admin-overview/admin-overview.component';
import { AdminUserManagementComponent } from 'src/app/pages/admin/admin-user-management/admin-user-management.component';
import { RouteGuardAdminService } from 'src/app/services/route-guard-admin.service';
import { RoutingID } from '../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { QueryPerformanceComponent } from '../../pages/admin/performance/query/query-performance.component';
import { EndpointPerformanceComponent } from '../../pages/admin/performance/endpoint/endpoint-performance.component';
import { AdminClientEditComponent } from '../../pages/admin/admin-client-management/admin-client-edit/admin-client-edit.component';
import { AdminClientLicencesComponent } from '../../pages/admin/admin-client-licence-management/admin-client-licences.component';
import { AdminMembershipComponent } from '../../pages/admin/admin-membership/admin-membership.component';
import { BackgroundWorkerComponent } from '../../pages/admin/admin-backgroundworker/background-worker.component';

export const admin: Route = {
  path: 'admin',
  component: AdminHomeComponent,
  data: {
    icon: '',
    breadcrumb: '',
    id: RoutingID.admin,
  },
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: RoutingID.adminOverview,
    },
    {
      path: 'admin-overview',
      component: AdminOverviewComponent,
      title: 'Admin',
      data: {
        icon: SbIcons.security,
        breadcrumb: 'Admin',
        id: RoutingID.adminOverview,
      },
    },
    {
      path: 'admin-users',
      component: AdminUserManagementComponent,
      canActivate: [RouteGuardAdminService],
      title: 'Users',
      data: {
        icon: SbIcons.userManagement,
        breadcrumb: 'Users',
        id: RoutingID.adminUserManagement,
      },
    },
    {
      path: 'admin-clients',
      title: 'Clients',
      data: {
        icon: SbIcons.companyClient,
        breadcrumb: 'Clients',
        id: RoutingID.adminClientManagement,
      },
      children: [
        {
          path: '',
          component: AdminClientManagementComponent,
          canActivate: [RouteGuardAdminService],
          data: {
            breadcrumb: '',
          },
        },
        {
          path: 'admin-clients-edit/:clientID',
          title: 'Client-Edit',
          data: {
            breadcrumb: 'Client-Edit',
            icon: SbIcons.edit,
            id: RoutingID.adminClientManagementEdit,
          },
          children: [
            {
              path: '',
              canActivate: [RouteGuardAdminService],
              component: AdminClientEditComponent,
              data: {
                breadcrumb: '',
              },
            },
          ],
        },
        {
          path: 'admin-clients-create',
          title: 'Client-Create',
          data: {
            breadcrumb: 'Client-Create',
            icon: SbIcons.plus,
            id: RoutingID.adminClientManagementCreate,
          },
          children: [
            {
              path: '',
              canActivate: [RouteGuardAdminService],
              component: AdminClientEditComponent,
              data: {
                breadcrumb: '',
              },
            },
          ],
        },
        {
          path: ':clientID/licences',
          title: 'Client Licences',
          data: {
            breadcrumb: 'Client Licences',
            icon: SbIcons.bookingList,
            id: RoutingID.adminClientLicences,
          },
          children: [
            {
              path: '',
              canActivate: [RouteGuardAdminService],
              component: AdminClientLicencesComponent,
              data: {
                breadcrumb: '',
              },
            },
          ],
        },
      ],
    },
    {
      path: 'queryPerformance',
      component: QueryPerformanceComponent,
      canActivate: [RouteGuardAdminService],
      title: 'nav.admin.queryPerformance',
      data: {
        icon: SbIcons.lineChart,
        breadcrumb: 'nav.admin.queryPerformance',
        id: RoutingID.queryPerformance,
      },
    },
    {
      path: 'endpointPerformance',
      component: EndpointPerformanceComponent,
      canActivate: [RouteGuardAdminService],
      title: 'nav.admin.endpointPerformance',
      data: {
        icon: SbIcons.lineChart,
        breadcrumb: 'nav.admin.endpointPerformance',
        id: RoutingID.endpointPerformance,
      },
    },
    {
      path: 'userMembership',
      component: AdminMembershipComponent,
      canActivate: [RouteGuardAdminService],
      title: 'nav.admin.userMembership',
      data: {
        icon: SbIcons.users,
        breadcrumb: 'nav.admin.userMembership',
        id: RoutingID.userMembership,
      },
    },
    {
      path: 'webWorker',
      component: BackgroundWorkerComponent,
      canActivate: [RouteGuardAdminService],
      title: 'WebWorker',
      data: {
        icon: SbIcons.settings,
        breadcrumb: 'WebWorker',
        id: RoutingID.backgroundWorker,
      },
    },
  ],
};
